<template>
  <div id="providerPage">

    <topnav :default_placeholder = "this.placeholder"></topnav>

    <main>
      <div id="providerContent" class="whiteBG">

        <div id="providerIntro">
            <img v-if="provider.image_url" id="providerLogo" :src="provider.image_url">
            <img v-else id="providerLogo" src="../../assets/img/empty/provider.svg">
            <div id="providerIntroText">
              <p v-if="provider.course_count>0" id="courseNumber">{{provider.course_count}} <span v-if="provider.course_count>1">courses</span><span v-else>course</span></p>
              <h1>{{provider.name}}</h1>
              <a :href="provider.link" v-if="provider.link" id="providerWebsite" class="brick">
                <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="linkChild">
                  <g id="--------4.a.3.-Course/Subject/Institute/Lecturer-Template" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="v1.1_3.3.1-Provider" transform="translate(-426.000000, -247.000000)" fill-rule="nonzero">
                      <g id="Group" transform="translate(120.000000, 132.000000)">
                        <g id="Group-3" transform="translate(306.000000, 40.000000)">
                          <g id="Group-2">
                            <path d="M7.74998152,90.7499958 C9.14581169,90.7499958 10.4374751,90.4010382 11.6249723,89.7031233 C12.8124695,89.0052085 13.7551757,88.0625022 14.4530905,86.8750051 C15.1510054,85.6875079 15.499963,84.3958445 15.499963,83.0000143 C15.499963,81.6041841 15.1510054,80.3125207 14.4530905,79.1250235 C13.7551757,77.9375264 12.8124695,76.9948201 11.6249723,76.2969053 C10.4374751,75.5989904 9.14581169,75.2500328 7.74998152,75.2500328 C6.35415136,75.2500328 5.06248793,75.5989904 3.87499076,76.2969053 C2.68749359,76.9948201 1.74478735,77.9375264 1.0468725,79.1250235 C0.34895766,80.3125207 0,81.6041841 0,83.0000143 C0,84.3958445 0.34895766,85.6875079 1.0468725,86.8750051 C1.74478735,88.0625022 2.68749359,89.0052085 3.87499076,89.7031233 C5.06248793,90.4010382 6.35415136,90.7499958 7.74998152,90.7499958 Z M10.1874757,80.0000215 L5.31248733,80.0000215 C5.56248674,78.8541907 5.92706936,77.9375264 6.40623473,77.2500304 C6.86456713,76.5833631 7.31248733,76.2500304 7.74998152,76.2500304 C8.18748048,76.2500304 8.63539592,76.5833631 9.09372832,77.2500304 C9.57289368,77.9375264 9.93747631,78.8541907 10.1874757,80.0000215 L10.1874757,80.0000215 Z M13.7812171,80.0000215 L11.2187233,80.0000215 C10.9270574,78.5833583 10.468725,77.4479441 9.84372653,76.5937796 C10.7187244,76.8646124 11.4947641,77.2969029 12.171846,77.8906515 C12.8489279,78.4844001 13.3853846,79.1875234 13.7812171,80.0000215 L13.7812171,80.0000215 Z M4.28123979,80.0000215 L1.7187459,80.0000215 C2.11457845,79.1875234 2.65103519,78.4844001 3.32811707,77.8906515 C4.00519894,77.2969029 4.7812386,76.8646124 5.65623651,76.5937796 C5.031238,77.4687775 4.57290561,78.6041913 4.28123979,80.0000215 L4.28123979,80.0000215 Z M10.3749753,85.0000191 L5.12498778,85.0000191 C5.04165449,84.3333446 4.99998808,83.6666792 4.99998808,83.0000191 C4.99998808,82.3333494 5.04165449,81.666684 5.12498778,81.0000191 L5.12498778,81.0000191 L10.3749753,81.0000191 C10.4583086,81.666684 10.499975,82.3333494 10.499975,83.0000191 C10.499975,83.6666792 10.4583086,84.3333446 10.3749753,85.0000191 L10.3749753,85.0000191 Z M4.12499017,85.0000191 L1.31249687,85.0000191 C1.10416388,84.3541776 0.999997616,83.6875127 0.999997616,83.0000191 C0.999997616,82.3125159 1.10416388,81.645851 1.31249687,81.0000191 L1.31249687,81.0000191 L4.12499017,81.0000191 C4.04165687,81.6875174 3.99999762,82.3593908 3.99999762,83.0156393 C3.99999762,83.6718877 4.04165687,84.3333446 4.12499017,85.0000191 L4.12499017,85.0000191 Z M14.1874662,85.0000191 L11.3749729,85.0000191 C11.4583062,84.3125112 11.4999726,83.6406378 11.4999726,82.9843893 C11.4999726,82.3281409 11.4583062,81.666684 11.3749729,81.0000191 L11.3749729,81.0000191 L14.1874662,81.0000191 C14.3957992,81.645851 14.4999654,82.3125159 14.4999654,83.0000191 C14.4999654,83.6875127 14.3957992,84.3541776 14.1874662,85.0000191 L14.1874662,85.0000191 Z M5.65623651,89.406249 C4.7812386,89.1354162 4.00519894,88.7031257 3.32811707,88.1093771 C2.65103519,87.5156285 2.11457845,86.8125052 1.7187459,86.0000072 L1.7187459,86.0000072 L4.28123979,86.0000072 C4.57290561,87.4166703 5.031238,88.5520846 5.65623651,89.406249 Z M7.74998152,89.7499982 C7.31248733,89.7499982 6.86456713,89.4166655 6.40623473,88.7500006 C5.92706936,88.0625022 5.56248674,87.1458379 5.31248733,86.0000072 L5.31248733,86.0000072 L10.1874757,86.0000072 C9.93747631,87.1458379 9.57289368,88.0625022 9.09372832,88.7500006 C8.63539592,89.4166655 8.18748048,89.7499982 7.74998152,89.7499982 Z M9.87497646,89.406249 C10.4791415,88.5312511 10.9270574,87.3958373 11.2187233,86.0000072 L11.2187233,86.0000072 L13.7812171,86.0000072 C13.3853846,86.8125052 12.8489279,87.5156285 12.171846,88.1093771 C11.4947641,88.7031257 10.7291409,89.1354162 9.87497646,89.406249 Z" id="g"></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
                <span class="a"> {{provider.link}}</span>
              </a>
              <p>{{provider.description}}</p>
            </div>
        </div>
        <div id="allCourses" v-if="provider.course_count>0">
          <p class="sectionTitle">Courses Provided by {{provider.name}}<router-link :to="{name:'all_courses_provider', params:{provider_id:this.provider.id,page:1}}" target="_blank" class="brick"><span class="viewall" v-if="provider.course_count>8">view all {{provider.course_count}} courses ></span></router-link></p>
          <div id="courseCardWrapper">
          <CourseCardSquare
            v-for="course in provider.featured_courses.slice(0,8)"
            :id="course.url_object_id"
            :key="course.url_object_id"
            :image="course.image_url"
            :title="course.name"
            :provider="provider.name"
            :platform="provider.platform"
            :domain="course.domain"
          ></CourseCardSquare>
          </div>
        </div>


        <div class="divider"></div>
        <div id="topInstructors" v-if="provider.instructor_count>0">
          <!--top 100 instructors-->
          <p class="sectionTitle">Top Instructors at {{provider.name}}<router-link :to="{name:'all_instructors_provider', params:{provider_id:this.provider.id}}" class="viewall brick" target="_blank">view all <span v-if="provider.instructor_count>1"class="a bold">instructors</span><span v-else class="a bold">instructor</span> ></router-link></p>
          <div id="instructorWrapper">
            <InstructorProfile
              v-for="instructor in provider.instructor_list.slice(0,6)"
              :id="instructor.id"
              :key="instructor.id"
              :avatar="instructor.image_url"
              :title="instructor.title"
              :subject="instructor.subject"
              :name="instructor.name"
              :course_number="instructor.course_count"
            >
            </InstructorProfile>
          </div>
        </div>

        <backto-top></backto-top>

      </div>
    </main>
    <Footer></Footer>

  </div>
</template>

<script>
import Topnav from '../General/Topnav'
import CourseCardSquare from '../General/CourseCardSquare'
import InstructorProfile from '../General/InstructorProfile'
import BacktoTop from '../General/BacktoTop'
import Footer from '../General/Footer'
import {getProvider} from "../../api/api";

export default {
  name: 'ProviderPage',
  components: {
    Topnav,
    CourseCardSquare,
    InstructorProfile,
    BacktoTop,
    Footer
  },
  metaInfo(){
      return{
          title: "Provider | "+this.provider.name
      }
  },
  data () {
    return {
      provider: {}
    }
  },
  methods:{
    getProviderInfo(){
      if (this.$route.params.provider_id) {
        getProvider({
          id: this.$route.params.provider_id
        }).then((response) => {
          this.provider = response.data
        })
      }
    }
  },
  created() {
    this.getProviderInfo();
  }
}
</script>

<style>
  @import '../../assets/style/general.css';
  @import '../../assets/style/page.css';

  #providerPage #providerWebsite{
    display: grid !important;
    grid-template-columns: 20px auto;
  }
  #providerPage #providerWebsite span {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /*tablet and laptop*/
  @media only screen
  and (max-device-width: 1200px) {
    #providerPage main{
      width:90%;
    }
    #providerPage #providerContent{
      padding: 30px 60px;
    }

  }

  /*phone*/
  @media only screen
  and (max-device-width: 600px) {
    #providerPage #providerContent{
      padding:30px 20px;
    }
    #providerPage #providerIntro{
      grid-template-columns: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Provider/ProviderPage.vue